import { render } from "./APPDownloadNow.vue?vue&type=template&id=2b206684"
import script from "./APPDownloadNow.vue?vue&type=script&lang=js"
export * from "./APPDownloadNow.vue?vue&type=script&lang=js"

import "./APPDownloadNow.vue?vue&type=style&index=0&id=2b206684&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__